import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy, Renderer2, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Route, Router, RouterOutlet } from '@angular/router';
import { f3Animations } from '@f3/animations';
import { faGrinTongueSquint } from '@fortawesome/free-solid-svg-icons';
import { map, Observable, of, Subject, takeUntil, tap } from 'rxjs';
import { CasualHireFormService } from './casual-hire-form.service';
import { Step, StepState as StepStateOptions } from './form-step.type';
import * as _ from 'lodash-es'
import { HireFormOrderSummaryComponent } from './order-summary/order-summary.component';
import { HireFormNavigationButtonComponent } from './navigation-button/navigation-button.component';
import { FormStepperComponent } from './form-stepper/form-stepper.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'casual-hire-form',
    templateUrl: './casual-hire-form.component.html',
    styleUrls: ['./casual-hire-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: f3Animations,
    standalone: true,
    imports: [FormStepperComponent, HireFormNavigationButtonComponent, NgClass, HireFormOrderSummaryComponent, RouterOutlet]
})
export class CasualHireFormComponent implements OnInit, OnDestroy {

    // @Public Properties
    // public currentStepValid$: Observable<boolean> = of(false);
    public currentStepValid: boolean = false;

    public showConfirmationPage = <boolean>false;

    public showNavigationButton = <boolean>false;

    public stripeFields!: () => { stripeCardNumber: any, stripCardExpiry: any, stripeCardCvc: any };

    public displayStepper: boolean;

    // @Private Properties
    private _unsubscribeAll: Subject<any> = new Subject;

    private _steps: Step[] = []

    private _scrollWatcher!: () => void;


    /**
    * Constructor
    */
    constructor (
        private _changeDetectorRef: ChangeDetectorRef,
        private _activatedRoute: ActivatedRoute,
        private _casualHireFormService: CasualHireFormService,
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
        private _router: Router
    ) { 

        this.displayStepper = false;

        this._router.events.subscribe({
            next: (event) => {
                if(event instanceof NavigationEnd) {
                    const urlSegments = event.url.split('/').filter(item => item !== '');
                    this.displayStepper = urlSegments.findIndex(seg => seg === 'intro') === -1
                }
            }
        })
       

     }


    //--------------------------------------------------------------------------------
    // @Lifecycle Hooks
    //--------------------------------------------------------------------------------

    /**
    * OnInit
    */
    ngOnInit(): void {


        //subscribe to the first child to determine whether to display the stepper
        this._activatedRoute.firstChild?.data.subscribe({
            next: (data: { displayStepper?: boolean}) => {
                //if the route has the displayStepper in the route then set the displayStepper to that otherwise true
                this.displayStepper = _.has(data, 'displayStepper') ? <boolean>data['displayStepper'] : true;
            }
        })


        this._casualHireFormService.steps$.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe({
            next: (steps) => {
                this._steps = steps
            }
        })


        this._casualHireFormService.currentStepValid$.pipe(
            map((value) => {
                this.currentStepValid = value;

                this._changeDetectorRef.detectChanges()

            })
        ).subscribe()

    }

    /**
     * 
     */
    ngAfterViewInit() {
        
        this._scrollWatcher = this._renderer2.listen('window', 'scroll', event => {
			this.showNavigationButton = this._elementRef.nativeElement.getBoundingClientRect().y < 155 ? true : false;
		})
    }

    /**
    * OnDestroy
    */
    ngOnDestroy() {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    //--------------------------------------------------------------------------------
    // @Public Methods
    //--------------------------------------------------------------------------------

    /**
     * 
     */
    public currentStep(): Step | null {
        return this._steps.find(step => step.state === StepStateOptions.INPROGRESS) || null
    }

    /**
     * next step
     */
    // public nextStep(): Step | null {
    //     return this._casualHireFormService.getNextStep();
    // }

    /**
     * show order sumary
     */
    public showOrderSummary() {
        return this.currentStep()?.includeOrderSummary
    }

    /**
     * 
     */
    // public goToNextStep() {
    //     this._casualHireFormService.goToNextStep(this._activatedRoute)
    // }

    


}